import {offerListConstraints} from "../constants/offer_list_constraints";
import {ISlugParsed} from "../helpers/friendly_offer_list/offer_url_parser";
import {getOfferListNearbyFilters} from "../helpers/getOfferListNearbyFilters";
import {ISelectedRegion} from "../list/actions/offer_list_selected_data_actions";
import {DEFAULT_DISTANCE_NEARBY_OFFERS} from "../list/constants/offer_list";

interface IGetListingPageNearbyOffersParams {
    offerParams: Partial<ISlugParsed> | null;
    singleRegion?: ISelectedRegion;
}

export function getListingPageNearbyOffersPayload(params: IGetListingPageNearbyOffersParams) {
    const {offerParams, singleRegion} = params;
    const filteringOptions = getOfferListNearbyFilters(offerParams, singleRegion);

    return {
        ...filteringOptions,
        ...offerListConstraints,
        page: 1,
        page_size: 3,
        distance: DEFAULT_DISTANCE_NEARBY_OFFERS
    };
}
import {offerListConstraints} from "../constants/offer_list_constraints";
import {ISlugParsed} from "../helpers/friendly_offer_list/offer_url_parser";
import {getOfferListNearbyFilters} from "../helpers/getOfferListNearbyFilters";
import {ISelectedRegion} from "../list/actions/offer_list_selected_data_actions";
import {DEFAULT_DISTANCE_NEARBY_OFFERS} from "../list/constants/offer_list";

interface IGetListingPageNearbyOffersParams {
    offerParams: Partial<ISlugParsed> | null;
    singleRegion?: ISelectedRegion;
}

export function getListingPageNearbyOffersPayload(params: IGetListingPageNearbyOffersParams) {
    const {offerParams, singleRegion} = params;
    const filteringOptions = getOfferListNearbyFilters(offerParams, singleRegion);

    return {
        ...filteringOptions,
        ...offerListConstraints,
        page: 1,
        page_size: 3,
        distance: DEFAULT_DISTANCE_NEARBY_OFFERS
    };
}
